export enum EInformerLevel {
  /** Менее важная информация об ОН **/
  Info = 'info',
  /** Важная информация об ОН, предупреждение **/
  Warning = 'warning',
}

export interface IRosreestrState {
  /** Подготовленная строка с датой актуальности данных **/
  actualDate?: string;
  /** Список информации из Росреестра **/
  items: IRosreestrItem[];
}

export interface IHoverTextSchema {
  /** Описание (список абзацев) **/
  description: string[];
  /** Заголовок **/
  title: string;
}

export interface IRosreestrItem {
  /** Название **/
  title: string;
  /** Свойства **/
  properties: IRosreestrItemValue[];
}

export interface IRosreestrItemValue {
  value: string;
  /** Тип текста для показа в модальном окне **/
  hoverText?: IHoverTextSchema | null;
  /** Уровень информера (Info/Warning) **/
  informerLevel?: EInformerLevel | null;
}
